const baseUrl = '/xapi/Voip/VosServer';
const baseUrl2 = '/xapi/User/User';
const moduleAjaxService = 'backend-service'
const api = {
    namespaced: true,
    state: {
        list: {},
        dropDownList: []
    },
    actions: {
        async userVOSCdr(context, params) {
            let userVOSType = '&userVOSType=' + params.userVOSType
            let username = '&username=' + (params.username || '')
            let vosServerId = '&vosServerId=' + (params.vosServerId || '')
            let cdrDate = '&cdrDate=' + (params.cdrDate || '')
            let page = '&page=' + (params.page || 1)
            let singleUser = '&singleUser=' + (params.singleUser || false)
            let search = (params.hasOwnProperty('search'))? "&userSearch=" + encodeURIComponent(params.search) : ''
            let filterProperty = (params.hasOwnProperty('filterProperty'))? "&filterProperty=" + encodeURIComponent(params.filterProperty) : ''

            let query = '?' + userVOSType + username + vosServerId + cdrDate + page + search + filterProperty + singleUser
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl2 + '/userVOSCdr' + query
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r.data);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async listVOSCdr(context, params) {
            let userVOSType = '&userVOSType=' + params.userVOSType
            let username = '&username=' + (params.username || '')
            let vosServerId = '&vosServerId=' + (params.vosServerId || '')
            let cdrDate = '&cdrDate=' + (params.cdrDate || '')
            let page = '&page=' + (params.page || 1)
            let search = (params.hasOwnProperty('search'))? "&userSearch=" + encodeURIComponent(params.search) : ''
            let filterProperty = (params.hasOwnProperty('filterProperty'))? "&filterProperty=" + encodeURIComponent(params.filterProperty) : ''

            let query = '?' + userVOSType + username + vosServerId + cdrDate + page + search + filterProperty
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl2 + '/listVOSCdr' + query
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r.data);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async downloadVosCdr(context, params) {
            let fileName = 'ffr-cdr'
            let fileType = 'xlsx'
            let userVOSType = 'userVOSType=' + (params.userVOSType || '')
            let username = '&username=' + (params.username || '')
            let vosServerId = '&vosServerId=' + (params.vosServerId || '')
            let cdrDate = '&cdrDate=' + (params.cdrDate || '')
            let responseType = (params.responseType || 'list')

            let query = '?' + userVOSType + username + vosServerId + cdrDate
            let url = process.env.VUE_APP_VOIP_GENERAL_BACKEND_SERVICE_URL + ":" + process.env.VUE_APP_VOIP_GENERAL_BACKEND_SERVICE_PORT + baseUrl2 + '/downloadVosCdr' + query;
            context.dispatch('app-state/downloadFile', {
                url, fileName: fileName + '.' + fileType
            }, {root: true})

        },
        async getTimeInterval(context, params) {
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/getDatesBetweenTwoDates/' + encodeURIComponent(params.userCreatedAtDate)
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r.data);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async get(context, params) {
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/get/' + params.id
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r.data);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async list(context, params) {
            let page = (params.page)? params.page : 1
            let noSearch = (params.search == undefined || params.search == '')



            let search = (params.hasOwnProperty('search'))? "&search=" + encodeURIComponent(params.search) : ''
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/list?page=' + page + search,
                data: null
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {

                    resolve(r.data);
                }).catch(e => {
                    reject(e);
                });
            })
        },
    },
    mutations: {
        RESET_CACHE (state, params) {
            state.list = {}
            state.dropDownList = []
        }
    }
};

export default api
